/**
 * Manda o botão de finalizar compra para o checkout da Yampi.
 *
 * O `YampiSnippet.liquid` só se intromete a partir de /cart: lá ele esconde o
 * botão nativo e coloca um clone que fala com a api.dooki. Em tema com cart
 * drawer o cliente nunca passa por /cart — o botão faz submit do form em
 * action="/cart" com name="checkout", que é o atalho para o checkout NATIVO da
 * Shopify. É por isso que a Yampi "não funciona": o pedido some no checkout
 * errado, sem nenhum erro na tela.
 *
 * Aqui o clique passa a chamar `yampiClick()`, a mesma função que o snippet
 * expõe globalmente (monta o checkout_direct_url com UTMs e _ga e redireciona).
 *
 * Em loja sem Yampi o arquivo é inerte: sem `yampiClick` no window, o submit
 * nativo acontece normalmente.
 */
(() => {
  // Se a Yampi demorar demais, /cart é a saída segura: lá o próprio snippet
  // assume. Melhor isso do que deixar o loader branco travado sobre a loja.
  const FALLBACK_DELAY = 8000;

  const isYampiActive = () => typeof window.yampiClick === 'function';

  /**
   * Cede a vez do checkout quando o HulkApps está na página.
   *
   * O `hulkcode.js` (app embed do Product Options, que carrega na loja inteira,
   * não só nos produtos personalizados) registra um handler jQuery em
   * `button[name="checkout"]` e, quando não existe `IntegrationCheckoutClick`
   * no window, manda o visitante para `/checkout?locale=…` — o checkout NATIVO
   * da Shopify. Ele navega antes de a `api.dooki` responder, então a Yampi
   * perde a corrida e o pedido termina no checkout errado, sem erro na tela.
   * Medido na LudMax em 21/08/2026: pelo botão do drawer, desktop e mobile
   * caíam em `/checkouts/cn/…`; pelo `/cart` funcionava, porque ali ninguém
   * clica em botão nenhum.
   *
   * `required: 0` é o contrato do próprio Hulk para "outro integrador cuida
   * disto": ele devolve false e não navega. Sem Yampi na página devolvemos 1, e
   * o Hulk segue para o checkout nativo — que é o certo numa loja sem Yampi.
   */
  if (typeof window.IntegrationCheckoutClick !== 'function') {
    window.IntegrationCheckoutClick = () => ({ required: isYampiActive() ? 0 : 1 });
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('#CartDrawer-Checkout, cart-drawer [name="checkout"]');
      if (!button || button.disabled) return;
      if (!isYampiActive()) return;

      event.preventDefault();

      window.setTimeout(() => {
        if (typeof window.hideYampiLoader === 'function') window.hideYampiLoader();
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      }, FALLBACK_DELAY);

      window.yampiClick();
    },
    // Fase de captura: o botão é recriado a cada re-render do drawer, e o form
    // do Dawn não pode chegar a submeter.
    true
  );

  /**
   * Devolve o "Adicionar ao carrinho" ao tema quando algum app carrega jQuery.
   *
   * O YampiSnippet tem um bloco inteiro protegido por `if (window.$ ||
   * window.jQuery)`. Em Dawn puro ele dorme, porque o tema não usa jQuery. Só
   * que basta um app de terceiro trazer jQuery para a página — na LudMax é o
   * HulkApps, nos produtos personalizados, com jQuery 3.7.1 — para o bloco
   * acordar: ele carimba o botão com `ymp_mainBtn`, dá preventDefault no clique,
   * adiciona por /cart/add.js e manda o visitante para
   * `/cart?ref=yampi_buy_button`. Com `skip_cart` ligado, /cart vira checkout na
   * hora. Resultado medido: nesse produto o "Adicionar ao carrinho" virava
   * "Comprar agora" e o carrinho lateral nunca abria.
   *
   * `stopImmediatePropagation` na captura mata o handler do snippet antes que
   * ele rode. Não é `preventDefault`: o botão continua sendo submit, o form
   * segue para o `product-form` do Dawn e o drawer abre como em qualquer outro
   * produto. O checkout pela Yampi não muda — ele acontece no botão do drawer,
   * logo acima.
   */
  document.addEventListener(
    'click',
    (event) => {
      const addButton = event.target.closest('[name="add"]');
      if (!addButton || !addButton.classList.contains('ymp_mainBtn')) return;

      event.stopImmediatePropagation();
    },
    true
  );
})();
